"use strict";

exports.__esModule = true;
exports.CalendarEventToField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var validate = function validate(input) {
  if (!input) {
    return "End time is required.";
  }
};
var CalendarEventToField = exports.CalendarEventToField = function CalendarEventToField(_ref) {
  var prefix = _ref.prefix;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: prefix + ".to",
    validate: validate
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("CalendarEventToField.helperText", "The time the event ends."),
      label: translate("CalendarEventToField.label", "To"),
      labelFor: prefix + ".to",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
      type: "time",
      required: true
    }, input)));
  });
};